import { browserFastApiClient } from "@/core/fastapi";
import {
  submitPublicFeedbackApiService,
  type SubmitPublicFeedbackRequest,
  type SubmitPublicFeedbackResult,
} from "@/generated/fastapi";

export async function submitPublicFeedback(
  token: string,
  request: SubmitPublicFeedbackRequest,
): Promise<SubmitPublicFeedbackResult> {
  const response = await submitPublicFeedbackApiService({
    client: browserFastApiClient,
    path: { token },
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to send feedback (${response.status})`);
  }

  if (response.data.status !== "created" && response.data.status !== "success") {
    throw new Error(response.data.message || "Failed to send feedback");
  }

  return response.data;
}
